<template>
  <div>
    <v-main>
      <v-container fluid>
        <app-headline :title="title" />

        <v-row>
          <v-col cols="12">
            <v-card
              class="pa-6"
              :class="{ 'px-12': $vuetify.breakpoint.smAndUp }"
            >
              <v-row class="pa-0 ma-0">
                <v-col class="pa-0 ma-0">
                  <history-table
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import HistoryTable from '@/components/history/HistoryTable.vue'

export default {
  components: {
    HistoryTable
  },

  data() {
    return {
      loading: true,
      fameList: []
    }
  },

  computed: {
    title() {
      return 'ประวัติการได้รับเครื่องราชฯ'
    },

    headers() {
      return [
        {
          text: 'ปีที่ได้รับ',
          value: 'receiveYear'
        },
        { text: 'ชั้น', value: 'fameName' },
        { text: 'ตำแหน่ง', value: 'positionName' },
        { text: 'ระดับ', value: 'classAllType' },
        {
          text: 'เอกสารอ้างอิง',
          value: 'referenceDocument'
        },
        {
          text: 'สถานะรับ / ส่งคืน',
          value: 'receiveReturnStatusName'
        },
        {
          text: 'ตรวจสอบ',
          value: 'requestChangeFlag',
          meta: 'requestChangeFlag'
        }
      ]
    },

    items() {
      const lang = this.$root.$i18n.locale
      return this.fameList.map(item => {
        item.fameName = item[`fameName${lang}`]
        return item
      })
    }
  },

  async mounted() {
    this.fameList = (await this.apiGetHistoryFames()) || []
    this.loading = false
  },

  methods: {
    async apiGetHistoryFames() {
      try {
        const res = await this.$store.dispatch('history/getFames', this.$guid)
        return res.data?.data?.fameList || []
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
